import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const RecentBlogs = (props) => {

    const blogs = props.Blogs ? (props.maxNumBlogs ? props.Blogs.slice(0, props.maxNumBlogs) : props.Blogs) : [];
    
    return (blogs && blogs.length > 0 &&
        <div className='blog-section'>
            <h2 className='section-title'>
                <span className='section-title-text'>
                    {props.CurrentSiteFullDomain + ' '} <TranslationText tKey='sandhills.blog' />
                </span>
            </h2>
            <div className='blog-feed'>
                <div className='blog-container'>
                    {blogs.map(post =>
                        <div key={post.Url} className='blog-home-post'>
                            <h3 className='blog-home-post-title'>
                                <a href={post.Url}>
                                    <strong>{post.PageHeader}</strong>
                                </a>
                            </h3>
                            <span className='blog-home-post-date'><strong><TranslationText tKey='sandhills.dealerservices.boards.mvc.posted' /> {post.DisplayLastUpdate ? post.UpdatedDateFormatted : post.PostedDateFormatted}</strong></span>
                            <span className='blog-home-post-content'>{post.SummaryPlainText}</span>
                            <a href={post.Url}><TranslationText tKey='sandhills.tradepubwebsite.mvc.readthefullblogpost' /></a>
                        </div>)}
                    <div className='blog-home-post'>
                        <a id='home-page-blog-archive' className='button ts-button' href={props.BlogArchiveURL}>
                            <strong><TranslationText tKey='sandhills.viewallblogposts' /></strong>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecentBlogs;